import { useAppContext } from '@context/app';
import { useUI } from '@context/ui-managed-context';
import HeartIcon from '@svg/HeartIcon';
import { useRouter } from 'next/router';
import React from 'react'

interface WishlistIconProps {
    productId: number;
    viewIndex?: number;
}

const WishlistIcon: React.FC<WishlistIconProps> = ({ productId, viewIndex }) => {
    const { wishlistProductIds, syncData } = useAppContext()
    const { setModalView, openModal } = useUI();
    const router = useRouter();
    const isInWishlist = wishlistProductIds.includes(productId);

    const syncViewIndexQuery = async () => {
        const hasGiftFinderContext =
            typeof router.query.gift_finder_session_token === "string" ||
            typeof router.query.gift_finder_session_id === "string";

        const nextQuery = { ...router.query };

        if (hasGiftFinderContext && typeof viewIndex === "number") {
            nextQuery.view_index = viewIndex.toString();
        } else {
            delete nextQuery.view_index;
        }

        await router.replace(
            {
                pathname: router.pathname,
                query: nextQuery,
            },
            undefined,
            {
                shallow: true,
                scroll: false,
            }
        );
    };

    const handleWishlistClick = async () => {
        if (syncData?.user) {
            await syncViewIndexQuery();
            setModalView("ADD_TO_WISHLIST_DRAWER", true, productId)
            openModal()
        } else {
            setModalView("LOGIN_VIEW", true, () => { })
            openModal()
        }
    }

    return (
        <div className="bg-white p-1 shadow-md rounded-md">
            <HeartIcon
                className={`cursor-pointer bg-white ${!isInWishlist && "hover:[&_path]:fill-gray-200 hover:scale-110 transition-all duration-300"}`}
                stroke="#008EC6"
                fill={isInWishlist ? "#008EC6" : "white"}
                onClick={(e) => {
                    e.stopPropagation()
                    void handleWishlistClick()
                }}
            />
        </div>
    )
}

export default WishlistIcon;